import React, { useState } from "react";

const SearchTerms = ({ children }) => {
  const [selectedTerm, setSelectedTerm] = useState();

  return children(selectedTerm, setSelectedTerm);
};

export default SearchTerms;
